import { PageHero, Container, Overline } from "../components/Section";

const WEEK = [
  { day: "Sunday", items: [
    { time: "8:30 AM", name: "Sunday School" },
    { time: "10:00 AM", name: "Worship Service" },
    { time: "12:30 PM", name: "Fellowship Lunch (1st Sunday)" },
  ] },
  { day: "Monday", items: [{ time: "6:30 PM", name: "Men of Valor (1st & 3rd)" }] },
  { day: "Tuesday", items: [{ time: "6:30 PM", name: "Women of Worth (2nd & 4th)" }] },
  { day: "Wednesday", items: [
    { time: "12:00 PM", name: "Noonday Bible Study" },
    { time: "7:00 PM", name: "Mid-Week Bible Study" },
  ] },
  { day: "Thursday", items: [
    { time: "6:30 PM", name: "Choir Rehearsal" },
    { time: "7:30 PM", name: "Praise Team Rehearsal" },
  ] },
  { day: "Friday", items: [{ time: "6:30 PM", name: "Youth Night (1st & 3rd)" }] },
  { day: "Saturday", items: [
    { time: "7:00 AM", name: "Morning Prayer" },
    { time: "10:00 AM", name: "Outreach (monthly)" },
  ] },
];

export default function ChurchSchedule() {
  return (
    <div data-testid="church-schedule-page">
      <PageHero
        overline="Church Schedule"
        title={<>The weekly <em className="text-gold-light italic font-light">rhythm</em> of our family.</>}
        kicker="From Sunday worship to mid-week study and Saturday prayer — here's how we gather."
        image="/images/branding/sanctuary-wide.jpg"
      />

      <Container className="pb-32">
        <div className="space-y-px bg-white/5">
          {WEEK.map((d) => (
            <div key={d.day} className="bg-wine-950 p-8 grid md:grid-cols-12 gap-6 items-start" data-testid={`schedule-${d.day.toLowerCase()}`}>
              <div className="md:col-span-3">
                <Overline>{d.day}</Overline>
              </div>
              <div className="md:col-span-9 space-y-3">
                {d.items.map((it) => (
                  <div key={it.name} className="flex items-baseline gap-6 pb-3 border-b border-white/5 last:border-0">
                    <span className="font-serif italic text-gold text-lg shrink-0 w-32">{it.time}</span>
                    <span className="text-white/85">{it.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
